import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, switchMap } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { Store } from '@ngrx/store';
import * as oeeAppReducer from '../../oee.reducer';
import { ActivityTimelineService } from '../../../shared/service/reports/activity-timeline/activity-timeline.service';
import * as ActivityTimelineActions from '../../reports/activity-timeline/activity-timeline.actions';
import { ResponseArrayInterface } from '../../../shared/model/interface/generic-api-response.model';
import { IActivityHistory } from '../../../shared/service/activity-history/activity-history.model';
import * as AppActions from '../../app/actions';
import { GetManyResponseInterface } from '../../../shared/model/interface/crud-response-interface.model';
import { IStationActivityHistoryCrudResponse } from '../../station-activity-history/station-activity-history.model';
import { IActivityTimelineFetchData } from './activity-timeline.model';

@Injectable()
export class ActivityTimelineEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly store: Store<oeeAppReducer.OeeAppState>,
    private readonly activityTimelineService: ActivityTimelineService,
  ) {}

  getActivityTimelineData = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivityTimelineActions.ActivityTimelineActionTypes.ActivityTimeLineDataLoading),
      switchMap((objectData: ActivityTimelineActions.ActivityTimeLineDataLoading) => {
        this.store.dispatch(new AppActions.ShowLoader());

        return from(this.activityTimelineService.loadInitialActivityData(objectData.activityTimeline)).pipe(
          switchMap(
            (response: {
              activityHistories: ResponseArrayInterface<IActivityHistory>;
              stationActivityHistories: GetManyResponseInterface<IStationActivityHistoryCrudResponse>;
            }) => {
              return of(
                new ActivityTimelineActions.ActivityTimeLineFetchData(
                  objectData.activityTimeline,
                  response.activityHistories.total,
                  response.stationActivityHistories.total,
                ),
              );
            },
          ),
          catchError((error) => {
            return of(new ActivityTimelineActions.FetchError(error), new AppActions.HideLoader());
          }),
        );
      }),
    ),
  );

  fetchData = createEffect(() =>
    this.actions$.pipe(
      ofType(ActivityTimelineActions.ActivityTimelineActionTypes.ActivityTimeLineFetchData),
      switchMap((objectData: ActivityTimelineActions.ActivityTimeLineFetchData) => {
        return this.activityTimelineService
          .fetchActivityTimelineData(
            objectData.activityTimeline,
            objectData.activityHistoryTotalCount,
            objectData.stationActivityHistoryTotalCount,
          )
          .pipe(
            switchMap((response: IActivityTimelineFetchData) => {
              const { activityTimeline, stationActivityHistories } =
                this.activityTimelineService.formatActivityTimelineResponse(response);

              return of(
                new ActivityTimelineActions.ActivityTimeLineDataLoaded({
                  activityTimeline,
                  stationActivityHistories,
                }),
                new AppActions.HideLoader(),
              );
            }),
            catchError((error) => {
              return of(new ActivityTimelineActions.FetchError(error), new AppActions.HideLoader());
            }),
          );
      }),
      catchError((errorRes) => {
        return of(new ActivityTimelineActions.FetchError(errorRes), new AppActions.HideLoader());
      }),
    ),
  );
}
